import { translateGradeLabel } from '../constants/gradeOptions';
import { getLocale, translate } from '../i18n';

// 화면 표시용 라벨 키 (서버 값은 그대로 두고 보여줄 때만 번역)
const STATUS_KEYS = ['APPLY'];
const PAYMENT_STATUS_KEYS = ['READY', 'PAID', 'CANCELLED'];

export function normalizeParticipantList(data) {
  const rawList = Array.isArray(data) ? data : data?.content ?? data?.data ?? [];

  return rawList
    .filter((item) => item?.id != null)
    .map((item) => ({
      id: item.id,
      memberId: item.memberId ?? null,
      competitionCode: item.competitionCode ?? '',
      competitionName: item.competitionName ?? '',
      associationName: item.associationName ?? '',
      gymName: item.gymName,
      coachName: item.coachName ?? '',
      grade: item.grade ?? '',
      participantName: item.participantName ?? '',
      name: item.participantName ?? '',
      participantPhone: item.participantPhone ?? '',
      parentPhone: item.parentPhone ?? '',
      birth: item.birth ?? '',
      gender: item.gender ?? '',
      height: item.height,
      status: item.status ?? '',
      orderId: item.orderId ?? '',
      paymentMethod: item.paymentMethod ?? '',
      paymentStatus: item.paymentStatus ?? '',
      amount: item.amount,
      appliedAt: item.appliedAt ?? '',
    }));
}

export function formatGender(gender) {
  if (gender === 'M') return translate('common.male');
  if (gender === 'F') return translate('common.female');
  return gender || '-';
}

export function formatHeight(height) {
  if (height == null || Number.isNaN(Number(height))) return '-';
  return translate('common.cm', { value: Number(height) });
}

export function formatAmount(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return '-';
  return translate('common.won', { value: Number(amount).toLocaleString(getLocale()) });
}

export function formatAppliedAt(appliedAt) {
  if (!appliedAt) return '-';
  const date = new Date(appliedAt);
  if (Number.isNaN(date.getTime())) return appliedAt;
  return date.toLocaleString(getLocale(), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatStatus(status) {
  if (STATUS_KEYS.includes(status)) return translate(`participants.status.${status}`);
  return status || '-';
}

export function formatPaymentStatus(paymentStatus) {
  if (PAYMENT_STATUS_KEYS.includes(paymentStatus)) {
    return translate(`participants.paymentStatus.${paymentStatus}`);
  }
  return paymentStatus || '-';
}

/** 저장된 학년 값('3학년', '대학교 2학년', '성인') → 현재 언어. 그 밖의 값은 그대로 */
export function formatGrade(grade) {
  return translateGradeLabel(grade);
}
